export default {
  deleteTitle: 'Program',
  overviewTitle: 'Programs',
  overviewRouterUrl: 'programs',
  getFilterName (context) { return 'programs' },
  overviewApiUrl: '/programs/',
  detailTitle: 'Program Detail',
  detailRouterUrl: 'program',
  detailApiUrl: '/programs/',
  quickFilterName: 'Name',
  quickFilterField: 'name',
  sortOrder: [
    {
      field: 'name',
      sortField: 'name',
      direction: 'asc'
    }
  ],
  fields:
  [
    {title: 'Name', name: 'name', sortField: 'name', link: '#/program/{id}'},
    {title: 'Short Name', name: 'shortname', sortField: 'shortname'},
    {name: '__slot:actions', title: '', titleClass: 'text-center', dataClass: 'text-center'}
  ]
}



// WEBPACK FOOTER //
// ./src/views/Program/FieldDefs.js